import { ShipmentInfo } from "src/main/types/cart";

export const getFullAddress = (data: ShipmentInfo) =>
  `${data.address}, ${data.city}, ${data.state}, ${data.postalCode}, ${data.country}`;
